import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
const CustomMultiSelect = ({ options, value, onChange }) => {
  const defaultItemRenderer = ({ checked, option, onClick, disabled }) => {
    return (
      <div className={`item-renderer ${disabled && 'disabled'}`}>
        <input
          type="checkbox"
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
        />
        <span>{option.label}</span>
      </div>
    );
  };
  const customItemRenderer = props => {
    if (props.option.label === 'Select All') {
      props.option.label = 'All locations';
    }
    return defaultItemRenderer(props);
  };

  return (
    <MultiSelect
      className="multiSelect_Component"
      options={options}
      value={value}
      onChange={onChange}
      labelledBy="Select"
      disableSearch
      hasSelectAll
      ItemRenderer={customItemRenderer}
      overrideStrings={{
        selectSomeItems: 'Location Selection',
        allItemsAreSelected: 'All locations',
      }}
    />
  );
};

export default CustomMultiSelect;
